import img01 from "../assets/images/OLYMPO310/ESTANDAR/salon-pasajeros---acabado-techo.jpg"
// import img02 from "../assets/images/olympo36/img02.jpg"
import img02 from "../assets/images/OLYMPO310/ESTANDAR/salon-pasajeros---acabado-lateral.jpg"
// import img03 from "../assets/images/olympo36/img03.jpg"
import img03 from "../assets/images/OLYMPO310/ESTANDAR/salon-pasajeros---acabado-piso.jpg"
// import img04 from "../assets/images/olympo36/img04.jpg"
import img04 from "../assets/images/OLYMPO310/ESTANDAR/salon-pasajeros---iluminacion.jpg"
// import img05 from "../assets/images/olympo36/img05.jpg"
// import img06 from "../assets/images/olympo36/img06.jpg"
import img06 from "../assets/images/OLYMPO310/ESTANDAR/cabina-conductor---cupula.jpg"
// import img07 from "../assets/images/olympo36/img07.jpg"
import img07 from "../assets/images/OLYMPO310/ESTANDAR/cabina-conductor---mampara-divisoria.jpg"
// import img08 from "../assets/images/olympo36/img08.jpg"
import img08 from "../assets/images/OLYMPO310/ESTANDAR/cabina-conductor---tablero-de-control.jpg"
// import img09 from "../assets/images/olympo36/img09.jpg"
import img09 from "../assets/images/OLYMPO310/ESTANDAR/cabina-conductor---grada-de-ingreso.jpg"
// import img10 from "../assets/images/olympo36/img10.jpg"
import img10 from "../assets/images/OLYMPO310/ESTANDAR/exterior-2.jpg"
// import img11 from "../assets/images/olympo36/img11.jpg"
import img11 from "../assets/images/OLYMPO310/ESTANDAR/exterior-3.jpg"
// import img12 from "../assets/images/olympo36/img12.jpg"
// import img13 from "../assets/images/olympo36/img13.jpg"
import img13 from "../assets/images/OLYMPO310/ESTANDAR/calefaccion.jpg"
// import img14 from "../assets/images/olympo36/img14.jpg"
import img14 from "../assets/images/OLYMPO310/ESTANDAR/salon-pasajeros---asientos.jpg"
// import img15 from "../assets/images/olympo36/img15.jpg"
import img15 from "../assets/images/OLYMPO310/OPCIONALES/aire-acondicionado.jpg"
// import img17 from "../assets/images/olympo36/img17.jpg"
import img17 from "../assets/images/OLYMPO310/ESTANDAR/conduccion---espejos-retrovisores.jpg"
// import img18 from "../assets/images/olympo36/img18.jpg"
import img18 from "../assets/images/OLYMPO310/ESTANDAR/conduccion---accionamiento-de-puerta-de-servicio.jpg"
import img19 from "../assets/images/OLYMPO310/ESTANDAR/conduccion---panel-de-control.jpg"
import img20 from "../assets/images/OLYMPO310/ESTANDAR/exterior-1.jpg"
export const OlympoBlock1 = [
  {
    title: `ACABADO TECHO`,
    text: `<li>Impermeable, de fácil limpieza, antinflamable y aislante térmico.</li>
    <li> Decorado con PVC DECORATIVO.</li>`,
    img: img01,
  },
  {
    title: `ACABADO LATERALES`,
    text: `<li>Impermeable, de fácil limpieza, antinflamable y aislante térmico.</li>
    <li> Perfilado de marcos de ventanas con PVC DECORATIVO de brillo natural.</li>`,
    img: img02,
  },
  {
    title: `ACABADO DE PISO`,
    text: `<li>Con PVC FLEXIBLE DE ALTO TRÁNSITO de alta resistencia al desgaste.</li>
    <li> Opciones de colores para el decorado del piso. Es antinflamable y retardante.</li>`,
    img: img03,
  },
  {
    title: `ILUMINACIÓN`,
    text: `<li>Iluminación con tecnología LED en ambos lados del salón.</li>`,
    img: img04,
  },
  {
    title: `ASIENTOS`,
    text: `<li>Ergonómicos inyectados en espuma de poliuretano flexible.</li>
    <li> Personalización de asientos de acuerdo a necesidades del cliente.</li>`,
    img: img14,
  },
  {
    title: `CALEFACCIÓN`,
    text: `<li>En base a paneles de serpentín.</li>`,
    img: img13,
  },
  // {
  //   title: `PAQUETERAS`,
  //   text: ` LIGERAS y elaboradas en poliuretano rigido de alta densidad. Fijadas en el techo estratégicamente para EVITAR VIBRACIONES. Luces de lectura individuales con iluminación independiente. `,
  //   img: img05,
  // },
]
export const OlympoBlock2 = [
  {
    title: `TABLERO DE CONTROL`,
    text: `<li>Diseño AERODINÁMICO elaborado en fibra de vidrio con colores elegantes.</li>
    <li> Su diseño FACILITA LA OPERACIÓN del bus.</li>`,
    img: img08,
  },
  {
    title: `GRADA DE INGRESO`,
    text: `<li>Fabricado en fibra de vidrio reforzada con estructura metálica.</li>
    <li> Iluminación propia con perfil aluminio con su respectiva luz de paso. </li>`,
    img: img09,
  },
  {
    title: `CÚPULA`,
    text: `<li>Techo de cabina hermetizado. Elaborado en fibra de vidrio con lineas estilizadas decorativas y definición de contornos para la colocación de accesorios de cabina.</li>`,
    img: img06,
  },
  {
    title: `MAMPARA DIVISORIA`,
    text: `<li>Diseño panorámico con vidrios templados de acuerdo a norma y fibra de vidrio.</li><li> Puerta amplia de acceso al salón de pasajeros. </li>`,
    img: img07,
  },
]
export const OlympoBlock3 = [
  {
    
    title:"ISO FRONTAL",
    text:'<li>AERODINÁMICO Y ELEGANTE</li>',
    img:img20
  },
  {
    title: ` <li>FRONTAL</li>`,
    text: `  <li>Mascara, Parachoque y Trampilla rebatible.</li>`,
    img: img10,
  },
  {
    title: `<li>BODEGAS</li>`,
    text: ` <li>AMPLIAS Y HERMÉTICAS</li>`,
    img: img11,
  }
  // {
  //   title: `BODEGAS`,
  //   text: ` Livianas, forradas en aluminio. Puertas de bodegas cuentan con mecanismo de seguridad de doble traba que garantizan un sello hermético.  `,
  //   img: img12,
  // },
]
export const OlympoBlock4 = [
  
  {
    title: `<li>AIRE ACONDICIONADO</li>`,
    text: `<li>Purifica y climatiza el aire del salón de pasajeros, garantizando comodidad y bienestar a los pasajeros.</li>`,
    img: img15,
  }
]
export const OlympoBlock5=[
  {
    title:"<li>ESPEJOS RETROVISORES</li>",
    text:`<li>Diseñados para obtener la mejor visibilidad de conducción. Mando eléctrico que regula el angulo de visión del conductor. </li><li>Espejos calefactables para climas humedos.</li>`,
    img:img17
  },
  {
    title:'<li>ACCIONAMIENTO PUERTA SERVICIO</li>',
    text:'<li>Accionado por aire y mando de accionamiento externo.</li>',
    img:img18
  },
  {
    title:'<li>PANEL DE CONTROL</li>',
    text:'<li>Panel digital con tecnología de circuitos impresos con protección “Anti – solder” que garantizan la funcionalidad correcta del bus en los diferentes climas y sin riesgo de cortocircuito.</li>',
    img:img19
  }
]


export const OlympoBlock6=[
  
  

]

